import { handleDispatchResult } from '@wajeez-web/core/utils';
import { store } from '@wajeez-web/stores/base';

import { getPromoCodeAliasesLookupsAsync } from './slices';

export const getPromoCodeAliasesLookups = async (
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getPromoCodeAliasesLookupsAsync());

  return handleDispatchResult(res, onSuccess);
};
